import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";
import { FieldDataProvider } from "../../../data-provider/field.dp";
import { Field } from "../../../models/field.model";
import { DashboardDataProvider } from "../../../data-provider/dashboard.dp";
import { DashboardWidget } from "../../../models/dashboard-widget.model";
import { ChartHelper } from "../../result/chart.helper";
import { Dashboard } from "../../../models/dashboard.model";
import { CanvassStatusDataProvider } from "../../../data-provider/canvass-status.dp";
import { CanvassStatus } from "../../../models/canvass-status.model";
import { DashboardWidgetFilter } from "../../../models/dashboard-widget-filter.model";
import { ActivityFilter } from "../../../models/activity-filter.model";

let CreateWidgetButtonComponent = {
    selector: "vcCreateWidgetButton",
    templateUrl:
        "/angular/components/dashboard/widget/create-widget-button.component.html",
    bindings: {
        dashboard: "=",
        globalFilter: "=",
    },
    controller: class CreateWidgetButtonController {
        // * bindings for typescript compiler *
        private globalFilter: DashboardWidgetFilter;
        private dashboard: Dashboard;
        // ************************************

        private $scope: any;
        private $rootScope: any;
        private dialog: DialogUtils;

        constructor($scope: any, $rootScope: any, DialogUtils: DialogUtils) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.dialog = DialogUtils;
        }

        $onInit() {}

        createWidgetDialog(ev: any) {
            this.dialog
                .show({
                    component: "vc-create-widget",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Duplicate Report",
                    size: "xx-large",
                    fullscreen: true,
                    forceFullscreen: true,
                    locals: {
                        dashboard: this.dashboard,
                        globalFilter: this.globalFilter,
                    },
                })
                .then((widget: any) => {
                    this.$rootScope.$broadcast("widgetCreated", widget);
                });
        }
    },
};

angular
    .module("dashboard")
    .component(
        CreateWidgetButtonComponent.selector,
        CreateWidgetButtonComponent
    );
